import React from 'react';

interface Props {
  shipped: number;
  ready: number;
  open: number;
  /** Closed as invalid: left out of the bar, like the percentages. */
  invalid?: number;
  /** A tick at this share (0 to 100), for a target. */
  marker?: number | null;
  markerLabel?: string;
  /** "h-2" by default. */
  height?: string;
}

// Shipped (dark green), release-ready (light green) and what is still open (the grey track), as
// shares of the tickets that count. The counts are always written next to it: the colours alone
// never carry the meaning.
export default function ProgressBar({ shipped, ready, open, invalid = 0, marker, markerLabel, height = 'h-2' }: Props) {
  const base = shipped + ready + open;
  const w = (n: number) => (base > 0 ? (n / base) * 100 : 0);
  const label = `${shipped} shipped, ${ready} release-ready, ${open} still open${invalid > 0 ? `, ${invalid} closed as invalid left out` : ''}`;
  return (
    <div className="relative" role="img" aria-label={label}>
      <div className={`flex ${height} overflow-hidden rounded-full bg-gray-200`}>
        <div className="bg-emerald-600 transition-[width] duration-300 ease-out motion-reduce:transition-none" style={{ width: `${w(shipped)}%` }} />
        <div className="bg-emerald-300 transition-[width] duration-300 ease-out motion-reduce:transition-none" style={{ width: `${w(ready)}%` }} />
      </div>
      {marker !== null && marker !== undefined && (
        <div
          className="absolute -top-1 bottom-[-0.25rem] w-0.5 rounded bg-gray-900"
          style={{ left: `${Math.min(100, Math.max(0, marker))}%` }}
          title={markerLabel}
          aria-hidden
        />
      )}
    </div>
  );
}
